import React, { useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { FooterSection } from '../types';
import { Link, useParams } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/auth-context'
import { RefundPolicy } from '../components/helpinfo/refund-policy';
import { TermsAndConditions } from '../components/helpinfo/terms-and-condition';
import { PrivacyPolicy } from '../components/helpinfo/privacy-policy';

const HelpInfo = () => {

    const { slug } = useParams();
    const { isAuth } = useAuth();
    
    const sections: FooterSection[] = [
        {
            title: 'Help & Info',
            links: [
                { title: 'Privacy Policy', href: '/help/privacy-policy' },
                { title: 'Terms & Conditions', href: '/help/terms-and-condition' },
                { title: 'Refund Policy', href: '/help/refund-policy' }
            ]
        },
    ];

    const currSection = sections[0].links.find(link => link.href === `/help/${slug}`);

    return (
        <section id="shop">
            <Container fluid>
                <Row className="bg-light justify-content-start mb-5">
                    <h1 className="section-title mt-4 mb-2 fs-2" data-aos="fade-up">Help &amp; Info</h1>
                    <span style={{fontSize: '.8rem'}} className='mb-4'>
                        {
                            isAuth ? (
                                <>
                                    <Link to="/customer/dashboard" className='text-success'>Dashboard</Link> 
                                    <ChevronRightIcon width={12} height={12} className='text-success' /> 
                                </>
                            ): (
                                <>
                                    <Link to="/" className='text-success'>Home</Link> 
                                    <ChevronRightIcon width={12} height={12} className='text-success' /> 
                                </>
                            )
                        }
                        <small>Help &amp; Info</small>
                    </span>
                </Row>
                <Row>
                    {/* Filter Column */}
                    <Col md={3} className="position-sticky bg-white" style={{ 
                        zIndex: 9, 
                        height: 'fit-content', 
                        boxShadow: '-12px 23px 23px #16141429', 
                        top: '74px',
                        marginBottom: '70px',
                    }}>
                        <div className="p-3">
                            <h5 className='mb-3'>Help &amp; Info</h5>
                            <ul className="menu-list list-unstyled text-uppercase border-animation-left fs-6">
                                {sections[0].links.map((link, linkIndex) => (
                                <li key={linkIndex} className={`menu-inner-item ${slug === link.href.split('/')[2] ? 'active' : ''}`}>
                                    <a href={link.href} className="item-anchor">{link.title}</a>
                                </li>
                                ))}
                            </ul>
                        </div>
                    </Col>

                    <Col md={8}>
                        {
                            (() => {
                                switch (slug) {
                                    case 'privacy-policy':
                                        return <PrivacyPolicy title={currSection?.title || ''} />
                                    case 'terms-and-condition':
                                        return <TermsAndConditions title={currSection?.title || ''} />
                                    case 'refund-policy':
                                        return <RefundPolicy title={currSection?.title || ''} />
                                    default:
                                        return <RefundPolicy title={currSection?.title || ''} />
                                }
                            })()
                        }
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default HelpInfo
